import { TypographyColor } from 'melp-design/components';
import { ExpenseStatus } from './expenses.types';

export const COLOR_BY_STATUS: Record<ExpenseStatus, TypographyColor> = {
  inProgress: 'warning',
  completed: 'success',
  paid: 'primary',
};
